import {  Component } from 'react'
import { Joystick } from 'react-joystick-component';
import { AssemblyJoystick } from '../compiler/assemblyBlocks/inputBlocks';
import { IJoystickUpdateEvent } from 'react-joystick-component/build/lib/Joystick';
import { Shape } from '../compiler/assemblyBlocks/shape/Shape';
import { ShapeType } from '../compiler/assemblyBlocks/shape/ShapeType';
import { Program } from '../compiler/Program';
import Canvas from './Canvas';
import '../styles/Runtime.scss';
import ReactDOM from 'react-dom';


interface Prop {
    program: Program;
}

interface State {
    inputs: any[]
}

// let lastX = 0;
// let lastY = 0;

interface InputValue {
    started: boolean,
    x: number,
    y: number
}

export default class Runtime extends Component<Prop, State> {
    program: Program;
    inputStorage: Map<string, InputValue>;

    constructor(props: Prop) {
        super(props);
        console.log("--RUNTIME           Entered Runtime constructor");
        this.state = ({
            inputs: []
        });
        this.program = props.program;
        this.inputStorage = new Map();

        this.draw = this.draw.bind(this);
        this.setup = this.setup.bind(this);

    }

    moveThing(inputVal: InputValue, inputName: string) {
        // console.log(inputVal, inputName);
        if (inputVal.started) {
            let newJoy: AssemblyJoystick = { x: inputVal.x, y: inputVal.y };
            this.program.varEnv.set(`&${inputName}`, newJoy);
            this.program.trigger(`${inputName}`); //! hope this work
        }
    }


    setup() {
        console.log("--RUNTIME           called setup !!!!", this.program.varEnv, this.program.triggerDict, "asdasd");
        if (this.program.triggerDict.size === this.state.inputs.length) return;

        this.program.varEnv.forEach((value: any, key: string) => {
            let joystickName = key.substring(1); // gets rid of the $
            if (value.type === "joy" && !this.inputStorage.has(joystickName)) {
                console.log("--RUNTIME           ", value);


                let joystick =
                    (<div className={joystickName} style={{ position: 'absolute', left: value.x, bottom: value.y }} key={joystickName}>
                        <Joystick
                            size={100}
                            baseColor="#7c7cf3"
                            stickColor="#efefef"
                            move={(e: IJoystickUpdateEvent) => { this.handleMove(e, joystickName) }}
                            stop={(e: IJoystickUpdateEvent) => { this.handleStop(e, joystickName) }}
                            start={(e: IJoystickUpdateEvent) => { this.handleStart(e, joystickName) }}>
                        </Joystick>
                    </div>);

                let inpVal: InputValue = {
                    started: false,
                    x: 0,
                    y: 0
                }

                this.inputStorage.set(joystickName, inpVal)
                this.setState(prevState => ({
                    inputs: [...prevState.inputs, joystick]
                }))
                this.program.varEnv.set(`&${joystickName}`, { x: 0, y: 0 });

            } else if (value.type === "btn") {
                // todo: haven't implemented yet 
            }
        })
    }

    componentDidMount() {
        this.setup();
    }

    draw(ctx: CanvasRenderingContext2D, frameCount: number) {
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
        if (this.state.inputs.length < this.program.triggerDict.size) {
            this.setup();
        }

        this.inputStorage.forEach((value: InputValue, key: string) => {
            this.moveThing(value, key);
        })


        if (this.program.subroutines.length > 0) { // Check if the program compiled   
            this.program.varEnv.forEach((value, key: string) => {
                switch (value.constructor) {
                    case Shape:
                        this.addShape(ctx, value);
                        break;
                    default:
                }
            });
        }
    }

    handleMove(e: IJoystickUpdateEvent, inputName: string) {
        if (e.x && e.y) {
            if (this.inputStorage.get(inputName)) {
                let newVals: InputValue = { started: this.inputStorage.get(inputName)?.started || true, x: e.x / 50, y: - 1 * (e.y / 50) };
                this.inputStorage.set(inputName, newVals);
            }
        }
    }

    handleStop(e: IJoystickUpdateEvent, inputName: string) {
        let newVals: InputValue = { started: false, x: 0, y: 0 }
        this.inputStorage.set(inputName, newVals);
    }

    handleStart(e: IJoystickUpdateEvent, inputName: string) {
        if (this.inputStorage.get(inputName)) {
            let newVals: InputValue = { started: true, x: this.inputStorage.get(inputName)?.x || 0, y: this.inputStorage.get(inputName)?.y || 0 }
            this.inputStorage.set(inputName, newVals);
        }
    }

    addShape(ctx: CanvasRenderingContext2D, element: Shape) {
        let shapeType: ShapeType = element.type;
        ctx.fillStyle = element.color;
        switch (shapeType) {
            case ShapeType.RECT:
                this.addRect(ctx, element.posX, element.posY, element.scaleX, element.scaleY);
                break;
            case ShapeType.CIRCLE:
                // addCircle(ctx, element.posX, element.posY, element.scaleX, element.scaleY);
                break;
            case ShapeType.TRIANGLE:
                // addTriangle(ctx, element.posX, element.posY, element.scaleX, element.scaleY);
                break;
            case ShapeType.HEART:
                // addHeart(ctx, element.posX, element.posY, element.scaleX, element.scaleY);
                break;
            case ShapeType.STAR:
                // addStar(ctx, element.posX, element.posY, element.scaleX, element.scaleY);
                break;
            default:
                // console.log('default');
                break;
        }

    }

    addRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number) {
        ctx.beginPath()
        ctx.rect(x, y, w, h);
        ctx.fill();
    }

    componentWillUnmount() {
        let comp = document.getElementById('controller');
        if (comp) {
            ReactDOM.unmountComponentAtNode(comp);
        }
    }

    render() {
        return (
            <div className="runtime-section">
                <div className="runtime-output">
                    <Canvas draw={this.draw} />
                    <div className="controller">
                        {this.state.inputs}
                    </div>
                </div>
            </div>
        );
    }
}

